import { graphql } from "~/gql";

export const UPDATE_DISCOUNT = graphql(/* GraphQL */ `
  mutation updateDiscount($data: DiscountUpdateInput!, $id: Float!) {
    updateDiscount(data: $data, id: $id) {
      ...DiscountParts
    }
  }
`);

export const UPDATE_DISCOUNTS = graphql(/* GraphQL */ `
  mutation updateDiscounts($data: [UpdateDiscountsInput!]!) {
    updateDiscounts(data: $data) {
      ...DiscountParts
    }
  }
`);
